import ClientTaskPage from './ClientTaskPage';

export default ClientTaskPage;